import { Asset, renderIcon } from '@opallabs/kuiper'
import { setTextEditorAssetData } from '@opallabs/periodic/src/contentTranslator/fromBackbonePost/dataSetters'
import { ScheduledTime } from '@opallabs/periodic/src/ScheduledTime'
import { CollaborationTextEditor } from '@opallabs/text-editor'
import { AccountName } from '../../../../../AccountName'
import { ContentAvatar } from '../../../../../ContentAvatar'
import { ContentTextInput } from '../../../../../ContentTextInput'
import * as sharedStyles from '../../styles'
import { LinkedInArticleDisplayProps } from '../../types'
import * as styles from './styles'

export const DesktopSingle = ({
  accountImage,
  accountName,
  accountSubtitle,
  assets,
  currentUser,
  externalAccessToken,
  isPresenting,
  isSnapshot,
  onAccountSubtitleChange,
  onExpandAsset,
  onPickAssets,
  onRemoveAsset,
  onTitleChange,
  readOnly,
  richTextDocumentId,
  scheduledAt,
  timezone,
  title,
  updateCaption,
}: LinkedInArticleDisplayProps) => {
  return (
    <div css={styles.wrapper}>
      <Asset
        assetReference={assets[0]}
        hasAssetOptions={!readOnly}
        hasAssetOverlay={!isSnapshot && (Boolean(assets[0]) || isPresenting)}
        imageFit="cover"
        onEmbiggen={() => assets[0]?.id && onExpandAsset(assets[0].id)}
        onRemove={() => assets[0]?.id && onRemoveAsset(assets[0].id)}
        overrideStyles={{ asset: styles.headerAssetOverrides }}
        placeholder={true}
        preview={isSnapshot}
        readOnly={readOnly}
        removeable={!isPresenting && !readOnly}
        updateCaption={updateCaption}
      />

      <div css={styles.contentWrapper}>
        <ContentTextInput
          characterCounterOptions={{ position: 'right', offset: 42 }}
          characterLimit={150}
          maxRows={3}
          minRows={1}
          onChange={onTitleChange}
          placeholder="Add text..."
          readOnly={readOnly}
          style={styles.titleStyleOverrides(readOnly)}
          value={title}
        />
        <div css={sharedStyles.accountWrapper}>
          <div css={sharedStyles.accountDetailsWrapper}>
            <ContentAvatar
              assetReference={accountImage}
              size={48}
              style={sharedStyles.accountAvatar}
            />
            <div css={sharedStyles.accountInputsWrapper}>
              <AccountName
                name={accountName}
                noAccountColor="#fab14d"
                size={16}
                style={sharedStyles.accountName}
              />
              <ContentTextInput
                characterCounterOptions={{ position: 'right', offset: 42 }}
                maxRows={1}
                minRows={1}
                onChange={onAccountSubtitleChange}
                placeholder="Add text..."
                readOnly={readOnly}
                style={styles.accountSubtitleStyleOverrides(readOnly)}
                value={accountSubtitle}
              />
            </div>
          </div>
          <div css={styles.fauxButtonsWrapper}>
            <div css={styles.fauxButtonsIconWrapper}>
              {renderIcon('linkedin-desktop-immersive-reader', {
                ariaMode: 'hidden',
              })}
            </div>
            <div css={styles.fauxButtonsIconWrapper}>
              {renderIcon('linkedin-desktop-save', { ariaMode: 'hidden' })}
            </div>
          </div>
        </div>
        <ScheduledTime
          css={sharedStyles.timestampStyleOverrides}
          color="black"
          dateFormat="MMMM d, yyyy"
          fontSize={12}
          timestamp={scheduledAt}
          timezone={timezone}
        />
      </div>

      <div css={styles.contentDocumentWrapper}>
        {richTextDocumentId && (
          <CollaborationTextEditor
            autofocus={false}
            css={styles.documentStyleOverrides(readOnly)}
            disableDoneButton={true}
            disableFullScreenAndCenterControls={true}
            disableReadMoreOverlay={true}
            disableViewModeSelector={true}
            disableLastSavedTime={true}
            documentId={richTextDocumentId}
            externalAccessToken={externalAccessToken}
            onPickAssets={async () => {
              const assetRefs = await onPickAssets({ destination: 'document' })
              return assetRefs.map(setTextEditorAssetData)
            }}
            placeholder="Add text..."
            readOnly={readOnly}
            user={
              currentUser
                ? {
                    uuid: currentUser.attributes.uuid as string,
                    name: currentUser.attributes.full_name as string,
                    type: 'user',
                    legacyId: currentUser.attributes.id!.toString(),
                    asset: currentUser.attributes.avatar_asset_reference
                      ? {
                          url:
                            currentUser.attributes.avatar_asset_reference
                              .attributes.full_url || '',
                        }
                      : undefined,
                  }
                : null
            }
          />
        )}
      </div>
    </div>
  )
}
